import { Component, inject } from '@angular/core';
import { observeParam } from '@suvo/frontend-framework/standalone/router/params';
import { IDashboardSettings } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/dashboards/interfaces/dashboard-settings.interface';
import { DashboardService } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/dashboards/services/dashboards.service';
import { DashboardSettingsService } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/dashboards/services/dashboards-settings.service';
import { combineLatest } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { IDynamicRouteData } from '../../../../../../app/dynamic-routes';

@Component({
  standalone: false,
  selector: 'suvo-bi-public-dashboard-screen',
  template: `
    <div
      class="dashboard-padding dashboard-container standard-padding"
      [class.no-padding]="!(dashboard | async)?.displayProperties?.padding"
    >
      @if (errorMessage | async; as errorMessage) {
        <suvo-core-error-message title="Something went wrong" [message]="errorMessage" />
      } @else if (dashboard | async) {
        <suvo-bi-dashboard [dashboard]="dashboard | async" [settings]="dashboardSettings | async" />
      }
    </div>
  `,
  styles: `
    .loading {
      height: 80vh;
    }

    .no-padding {
      padding: 0;
    }

    .dashboard-container {
      &::ng-deep .row-tiles-container > div.no-padding {
        padding: 0;

        .card {
          border-top-left-radius: 0px !important;
          border-top-right-radius: 0px !important;
          border-bottom-right-radius: 0px !important;
          border-bottom-left-radius: 0px !important;
          box-shadow: none !important;
        }
      }
    }
  `,
})
export class PublicDashboardScreenComponent {
  private readonly dashboardService = inject(DashboardService);
  private readonly dashboardSettingsService = inject(DashboardSettingsService);

  private readonly dynamicRouteData = observeParam<IDynamicRouteData>('data', 'dynamicRoute');

  protected readonly dashboard = this.dynamicRouteData.pipe(
    switchMap(async ({ variant }) => {
      const dashboardUuid = variant?.dashboardUuid;

      if (!dashboardUuid) {
        return;
      }

      const dashboard = await this.dashboardService.getLatestPublicDashboardByBaseId(
        variant.dashboardUuid,
      );

      if (!dashboard) {
        return;
      }

      await this.dashboardService.processTilesAgainstSubs(dashboard);

      console.log(dashboard);

      return dashboard;
    }),
  );

  protected readonly dashboardSettings = this.dynamicRouteData.pipe(
    map(({ current }) => {
      const dashboardSettings: IDashboardSettings = {
        canEdit: this.dashboardSettingsService.canEditDashboards,
        canEditJson: this.dashboardSettingsService.canEditDashboards,
        canFilter: !!current.filterGroup,
      };

      if (current.routeType === 'EXPORT') {
        dashboardSettings.filterGroup = current.filterGroup;
        dashboardSettings.filterLayout = {
          type: 'accordian',
          autoApplyFilters: true,
        };
      }

      return dashboardSettings;
    }),
  );

  protected readonly errorMessage = combineLatest([this.dynamicRouteData, this.dashboard]).pipe(
    map(([{ variant }, dashboard]) => {
      if (!variant?.dashboardUuid) {
        return 'This route has no content.';
      }

      if (!dashboard) {
        return 'Could not retrieve page content.';
      }
    }),
  );
}
